var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('upload-or-record-video',{attrs:{"record-new-video-button":true,"review-prompt-button":true,"classroom-id":_vm.classroomId,"task-id":_vm.teacherActionId},on:{"close-video-upload-modal":_vm.goToTaskDetailPage,"upload-video-success":_vm.uploadVideoSucess}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }